"use strict";
// @ts-ignore
try {
    self['workbox:core:6.0.2'] && _();
}
catch (e) { }
